var map = {
	"./druid": 526,
	"./druid.ts": 526,
	"./hunter": 837,
	"./hunter-pets": 965,
	"./hunter-pets.ts": 965,
	"./hunter.ts": 837,
	"./mage": 858,
	"./mage.ts": 858,
	"./paladin": 77,
	"./paladin.ts": 77,
	"./priest": 155,
	"./priest.ts": 155,
	"./rogue": 476,
	"./rogue.ts": 476,
	"./shaman": 158,
	"./shaman.ts": 158,
	"./warlock": 361,
	"./warlock-demons": 744,
	"./warlock-demons.ts": 744,
	"./warlock.ts": 361,
	"./warrior": 616,
	"./warrior.ts": 616
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 826;